// #region Imports
import { createStore } from 'vuex';
// #endregion
export default class StateFactory {
    // #region Vars
    _store;
    // #endregion
    // #region Properties
    get container() {
        return this._store.state;
    }
    get commit() {
        return this._store.commit;
    }
    get dispatch() {
        return this._store.dispatch;
    }
    get __store() {
        return this._store;
    }
    // #endregion
    // #region Constructor
    constructor() {
        // #region Store
        this._store = createStore({});
        // #endregion
    }
    // #endregion
    // #region Boostrap
    registerAll(context) {
        context.keys().forEach(e => {
            //View
            let tStore = context(e).default;
            if (tStore) {
                this.registerModule(utils.getPathInfo(e).name, tStore);
            }
        });
    }
    registerModule(path, module, options) {
        if (utils.isArray(path)) {
            this._store.registerModule(path, module, options);
        }
        else {
            this._store.registerModule(path, module, options);
        }
    }
    unregisterModule(path) {
        if (utils.isArray(path)) {
            this._store.unregisterModule(path);
        }
        else {
            this._store.unregisterModule(path);
        }
    }
    // #endregion
    // #region Core
    list() {
        return Object.keys(this._store.state);
    }
    get(name) {
        return this._store.state[name];
    }
    getAs(name) {
        return this._store.state[name];
    }
    getters() {
        return this._store.getters;
    }
    getter(name, args) {
        var tData = this._store.getters[name];
        {
            if (utils.isFunction(tData)) {
                return tData(args);
            }
            else {
                return tData;
            }
        }
    }
    watch(getter, cb, options) {
        this._store.watch(getter, cb, options);
    }
    subscribe(fn, options) {
        this._store.subscribe(fn, options);
    }
    subscribeAction(fn, options) {
        this._store.subscribeAction(fn, options);
    }
    hasModule(path) {
        if (utils.isArray(path)) {
            this._store.hasModule(path);
        }
        else {
            this._store.hasModule(path);
        }
    }
}
